"use client";

import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function GetInTouch() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const contactDetails = [{
    label: "Call Us",
    value: "(305) 935.6066",
    href: "tel:+13059356066",
    icon: Phone
  }, {
    label: "Email Us",
    value: "info@tmprosthodontics.com",
    href: "mailto:info@tmprosthodontics.com",
    icon: Mail
  }, {
    label: "Visit Us",
    value: "20760 W. Dixie Highway Miami, FL 33180",
    href: "https://maps.google.com",
    icon: MapPin,
    newTab: true
  }];
  return <section data-section-id="46319" id="connect-with-us" className="bg-secondary py-20 lg:py-28 overflow-hidden">
      <div className="container mx-auto px-6 max-w-7xl">
        <div ref={ref} className={cn("flex flex-col lg:flex-row gap-16 lg:gap-24 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
          {}
          <div className="w-full lg:w-2/5 flex flex-col justify-center">
            <span className="text-primary font-sans font-medium tracking-widest uppercase mb-4 text-sm">
              Contact
            </span>
            <h2 className="text-4xl lg:text-5xl font-serif font-bold text-white mb-6 leading-tight">
              Connect With <span className="text-primary">Us</span>
            </h2>
            <p className="text-sm text-white/70 font-sans leading-relaxed">Dr. Leclercq and our specialized team are dedicated to providing the highest level of prosthodontic care. Whether you require complex reconstruction or aesthetic enhancement, we are here to guide you toward your perfect smile with precision, artistry, and clinical excellence.</p>
          </div>

          {}
          <div className="w-full lg:w-3/5 flex flex-col justify-center gap-6">
            {contactDetails.map((item, i) => <div key={i} data-index={i}>
                <Link to={item.href} newTab={item.newTab} className="group flex items-center gap-6 p-6 -mx-6 rounded-lg transition-all duration-300 hover:bg-white/5">
                  {}
                  <div className="relative flex items-center justify-center size-20 shrink-0 rounded-full transition-colors duration-300 bg-transparent group-hover:bg-primary/10">
                    <item.icon className="size-10 text-primary transition-transform duration-300 group-hover:scale-110" strokeWidth={1.5} />
                  </div>

                  {}
                  <div className="flex flex-col">
                    <span className="text-xs font-medium text-white/60 uppercase tracking-widest mb-1">
                      {item.label}
                    </span>
                    <span className="text-2xl md:text-3xl font-bold text-primary font-serif group-hover:text-primary/80 transition-colors">
                      {item.value}
                    </span>
                  </div>
                </Link>
                {}
                {i < contactDetails.length - 1 && <div className="h-px w-full bg-border/30 mx-auto lg:hidden" />}
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}